"use client";

import React from "react";
import { MessageCircleQuestionMark, Sparkles } from "lucide-react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const faqs = [{
  question: "¿Qué requisitos necesito para inscribirme?",
  answer: "Para la mayoría de nuestros cursos de oficios y estética solo necesitas ser mayor de 15 años y tener ganas de aprender. No se requieren conocimientos previos avanzados, ya que comenzamos desde los fundamentos básicos en cada área."
}, {
  question: "¿Dónde se dictan las clases de ECAP?",
  answer: "Tenemos una fuerte presencia en todo el interior de Uruguay. Dictamos clases en centros locales especialmente equipados para que realices tus prácticas de electricidad, barbería o masoterapia con la comodidad y herramientas necesarias."
}, {
  question: "¿Recibiré un diploma al terminar el curso?",
  answer: "¡Claro que sí! Al completar satisfactoriamente tu capacitación y aprobar las evaluaciones, recibirás el certificado oficial de ECAP (Escuela de Capacitaciones Privadas), que respalda tus conocimientos para trabajar de forma independiente o en empresas."
}, {
  question: "¿Cómo puedo abonar mi capacitación?",
  answer: "Entendemos la realidad de nuestros alumnos, por eso ofrecemos facilidades de pago en cuotas mensuales fijas. Puedes abonar en efectivo, mediante transferencia bancaria o con las principales tarjetas de crédito del país."
}, {
  question: "¿Los cursos incluyen materiales de práctica?",
  answer: "Sí, en cursos técnicos como Electricista o de estética como Barbería, la academia provee los insumos básicos y herramientas para las demostraciones y prácticas iniciales, asegurando que todos los estudiantes puedan aprender haciendo."
}];
export default function PreguntasDeAspirantes() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section data-section-id="38097" id="preguntas-frecuentes" className="dark bg-background text-foreground py-24 px-4 relative overflow-hidden">
      {}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full h-full max-w-7xl pointer-events-none">
        <div className="absolute top-20 left-10 w-72 h-72 bg-primary/20 rounded-full blur-[100px] opacity-30 animate-pulse" />
        <div className="absolute bottom-20 right-10 w-96 h-96 bg-secondary/20 rounded-full blur-[120px] opacity-20" />
      </div>

      <div ref={ref} className={`relative z-10 max-w-3xl mx-auto transition-all duration-1000 ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}>
        <div className="text-center mb-16 space-y-4">
          <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-secondary/10 border border-secondary/20 text-secondary text-sm font-semibold mb-4 tracking-wide uppercase">
            <Sparkles className="w-4 h-4" />
            <span>Dudas Frecuentes</span>
          </div>
          <h2 className="text-4xl md:text-5xl font-bold tracking-tighter bg-clip-text text-transparent bg-gradient-to-b from-white to-white/70 font-sans">
            Preguntas de Aspirantes
          </h2>
          <p className="text-muted-foreground text-lg max-w-2xl mx-auto font-sans">
            Resolvemos las dudas más comunes para que puedas comenzar tu formación profesional en ECAP con total confianza y respaldo.
          </p>
        </div>

        <Accordion type="single" collapsible className="w-full space-y-4">
          {faqs.map((faq, i) => <AccordionItem key={i} value={`item-${i}`} data-index={i} className="group border border-white/5 bg-card/40 backdrop-blur-md rounded-3xl px-2 transition-all duration-300 data-[state=open]:border-secondary/50 data-[state=open]:bg-card/60 data-[state=open]:shadow-[0_0_40px_-15px_var(--color-secondary)] hover:border-white/10">
              <AccordionTrigger className="px-4 py-6 text-left text-base md:text-lg font-bold hover:no-underline hover:text-secondary transition-colors [&[data-state=open]]:text-secondary font-sans">
                {faq.question}
              </AccordionTrigger>
              <AccordionContent className="px-4 pb-6 text-muted-foreground text-base leading-relaxed font-sans">
                {faq.answer}
              </AccordionContent>
            </AccordionItem>)}
        </Accordion>

        <div className="mt-12 text-center">
          <p className="text-muted-foreground mb-6 font-sans">
            ¿Tienes alguna otra consulta específica? Estamos para asesorarte.
          </p>
          <Button asChild size="lg" className="bg-secondary hover:bg-secondary/90 text-secondary-foreground font-bold rounded-2xl shadow-[0_0_20px_-5px_var(--color-secondary)] hover:shadow-[0_0_35px_-5px_var(--color-secondary)] transition-all duration-300">
            <Link to="https://wa.me/59896344395" newTab>
              <MessageCircleQuestionMark className="mr-2 h-5 w-5" />
              WhatsApp
            </Link>
          </Button>
        </div>
      </div>
    </section>;
}